// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {BlockText} from '../search-index/block-text.js'

export class TextSearchIndex {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): TextSearchIndex {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsTextSearchIndex(bb: flatbuffers.ByteBuffer, obj?: TextSearchIndex): TextSearchIndex {
    return (obj || new TextSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsTextSearchIndex(bb: flatbuffers.ByteBuffer, obj?: TextSearchIndex): TextSearchIndex {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new TextSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  blocks(index: number, obj?: BlockText): BlockText | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset
      ? (obj || new BlockText()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  blocksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  version(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  static startTextSearchIndex(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, textOffset, 0)
  }

  static addBlocks(builder: flatbuffers.Builder, blocksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, blocksOffset, 0)
  }

  static createBlocksVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startBlocksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addVersion(builder: flatbuffers.Builder, version: number) {
    builder.addFieldInt32(2, version, 0)
  }

  static endTextSearchIndex(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // text
    builder.requiredField(offset, 6) // blocks
    return offset
  }

  static createTextSearchIndex(
    builder: flatbuffers.Builder,
    textOffset: flatbuffers.Offset,
    blocksOffset: flatbuffers.Offset,
    version: number
  ): flatbuffers.Offset {
    TextSearchIndex.startTextSearchIndex(builder)
    TextSearchIndex.addText(builder, textOffset)
    TextSearchIndex.addBlocks(builder, blocksOffset)
    TextSearchIndex.addVersion(builder, version)
    return TextSearchIndex.endTextSearchIndex(builder)
  }
}
